import NavigationItemsContext from "app/contexts/app/NavigationItemsContext";
import { useContext } from "react";

const useNavigationItems = () => useContext(NavigationItemsContext);

export default useNavigationItems;
